import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetNotTreatedAPI = api.create('dponet', false)

const get = async ({ governanceProjectId = '', ...params }) => {
  return await dponetAPI.get(`/governance_projects/${governanceProjectId}`, {
    params,
  })
}

const create = async ({ ...data }) => {
  return await dponetNotTreatedAPI.post('/governance_projects', {
    governanceProject: data,
  })
}

const update = async ({ governanceProjectId, ...data }) => {
  return await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}`,
    {
      governanceProject: data,
    },
  )
}

const changeStatus = async ({ governanceProjectId, ...data }) => {
  return await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/change_status`,
    {
      governanceProject: data,
    },
  )
}

const softDelete = async ({ governanceProjectId, ...data }) => {
  return await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/soft_delete`,
    {
      governanceProject: data,
    },
  )
}

const deletePlanAction = async ({ governanceProjectId, planActionId }) => {
  return await dponetNotTreatedAPI.delete(
    `/governance_projects/${governanceProjectId}/plan_actions/${planActionId}`,
  )
}

const changeStatusPlanAction = async ({
  governanceProjectId,
  planActionId,
  planAction,
}) => {
  return await dponetNotTreatedAPI.patch(
    `/governance_projects/${governanceProjectId}/plan_actions/${planActionId}/change_status`,
    { planAction },
  )
}

const listEvidencePlanActions = async ({
  governanceProjectId = '',
  ...params
}) => {
  return await dponetAPI.get(
    `/governance_projects/${governanceProjectId}/evidence_plan_actions`,
    { params },
  )
}

const answerPlanAction = async ({
  governanceProjectId,
  governanceProjectActivityId,
  evidencePlanActions,
}) => {
  return await dponetNotTreatedAPI.postForm(
    `/governance_projects/${governanceProjectId}/evidence_plan_actions/answer`,
    {
      governanceProjectActivityId,
      evidencePlanActions,
    },
  )
}

const destroyEvidencePlanAction = async ({
  governanceProjectId,
  evidencePlanActionId,
}) => {
  return await dponetNotTreatedAPI.delete(
    `/governance_projects/${governanceProjectId}/evidence_plan_actions/${evidencePlanActionId}`,
  )
}

const removeEvidenceDocument = async ({
  governanceProjectId,
  evidencePlanActionId,
  documentId,
}) => {
  return await dponetNotTreatedAPI.delete(
    `/governance_projects/${governanceProjectId}/evidence_plan_actions/${evidencePlanActionId}/document/${documentId}`,
  )
}

const removeEvidencePlatformDocument = async ({
  governanceProjectId,
  evidencePlanActionId,
  documentId,
}) => {
  return await dponetNotTreatedAPI.delete(
    `/governance_projects/${governanceProjectId}/evidence_plan_actions/${evidencePlanActionId}/linked_document/${documentId}`,
  )
}

const sendToSegcoop = async ({ governanceProjectId }) => {
  return await dponetAPI.post(
    `/governance_projects/${governanceProjectId}/send_to_segcoop`,
  )
}

const segcoopList = async () =>
  await dponetAPI.get('/governance_projects/segcoop_list')

const importFromSegcoop = async ({ token }) =>
  await dponetAPI.post('/governance_projects/import', {
    governanceProject: { token },
  })

const retryImport = async ({ governanceProjectId }) =>
  await dponetAPI.post(
    `governance_projects/${governanceProjectId}/retry_import`,
  )

const getImportStatus = async ({ governanceProjectId }) =>
  await dponetAPI.get(
    `governance_projects/${governanceProjectId}/import_status`,
  )

export default {
  get,
  create,
  update,
  changeStatus,
  softDelete,
  deletePlanAction,
  changeStatusPlanAction,
  listEvidencePlanActions,
  answerPlanAction,
  removeEvidenceDocument,
  destroyEvidencePlanAction,
  removeEvidencePlatformDocument,
  sendToSegcoop,
  segcoopList,
  importFromSegcoop,
  retryImport,
  getImportStatus,
}
